import { useEffect, useState } from "react";
import { NewsArchive } from "@/components/News";
import { PageHeader } from "@/components/ui/design-system";
import { Button } from "@/components/ui/button";
import { news, type NewsRelease } from "@/lib/news";

export function NewsPage() {
  const [releases, setReleases] = useState<NewsRelease[] | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    void news
      .load(controller.signal)
      .then((data) => {
        if (!controller.signal.aborted) setReleases(data.releases);
      })
      .catch(() => {
        if (!controller.signal.aborted) setFailed(true);
      });
    return () => controller.abort();
  }, [attempt]);
  return (
    <div className="help-page">
      <PageHeader title="Što je novo" />
      {failed ? (
        <div role="alert">
          <p>Novosti nisu dostupne. Pokušajte ponovno.</p>
          <Button
            variant="secondary"
            onClick={() => {
              setFailed(false);
              setAttempt(attempt + 1);
            }}
          >
            Pokušaj ponovno
          </Button>
        </div>
      ) : releases ? (
        <NewsArchive releases={releases} />
      ) : (
        <p role="status">Učitavanje novosti…</p>
      )}
    </div>
  );
}
